import React from 'react';
import { Alert } from 'ui';
import { useFileUpload } from '../../contexts/FileUploadContext';

const FileUploadAlert = () => {
  const { fileStatus, showModal, clearFiles } = useFileUpload();
  
  // Don't render if no file status
  if (!fileStatus) return null;
  
  const { hasError, isDone, message, errorMessage } = fileStatus;
  const alertStyle = hasError ? 'danger' : 'info';
  
  const seeStatusLink = <span>. <b>See status.</b></span>;
  const shouldShowStatusLink = !isDone && !hasError;

  return (
    <div style={{
      position: "absolute", 
      cursor: "pointer", 
      right: "10px", 
      top: "10px", 
      zIndex: 1
    }}>
      <Alert 
        onDismiss={isDone ? clearFiles : null}
        variant={alertStyle}
        onClick={showModal}
        style={{ width: "400px" }}
      >
        <div>
          {message}
          {shouldShowStatusLink && seeStatusLink}
        </div>
        {errorMessage && (
          <div>
            {errorMessage}{seeStatusLink}
          </div>
        )}
      </Alert>
    </div>
  );
};

export default FileUploadAlert;